const count = (n, one, many) => `${n} ${n === 1 ? one : many}`;

function dailyWhat(h) {
  if (h.isTest) return `Test email, ${h.sent} sent`;
  const n = (h.events ?? []).reduce((sum, e) => sum + (e.count ?? 0), 0);
  return `Daily email: ${count(n, 'event', 'events')}, ${h.sent} sent`;
}

/**
 * The Overview feed: Watch events (admin notices excluded, they have their own group) and the daily
 * collection sends, newest first. `events` is null for an operator account.
 */
export function buildFeedRows({ events = [], history = [] } = {}) {
  const live = (events ?? [])
    .filter((e) => e.noticeClass !== 'admin-notice')
    .map((e) => ({ id: `live:${e.eventId}`, source: 'live', when: e.activityDateTime, what: e.what, severity: e.severity ?? null, answer: e.answerState ?? null, eventId: e.eventId, event: e }));
  const daily = (history ?? []).map((h, i) => ({ id: `daily:${h.sentAt}:${i}`, source: 'daily', when: h.sentAt, what: dailyWhat(h), severity: null, answer: null, eventId: null, history: h }));
  return [...live, ...daily].sort((a, b) => Date.parse(b.when) - Date.parse(a.when));
}
